import React, {useEffect, useState} from "react";
import {PaginationSection, TableContent} from "../../../../library";
import {columns, columns1} from "./billingColumns";
import {fetchApiGw} from "../../../../_config/api";
import {dateformatter, deepCopy,} from "../../../../deps";
import Skeleton from "react-loading-skeleton";
import Restricted from "../../../../../auth/Restricted";



export const PlanBilling = ({showLoader,activeKey,isLoading}) => {

    const [pageSetting, setSetting] = React.useState({
        page: 1,
        itemsPerPage: 10,
        searchTextBilling: "",
        searchTextConsump:"",
        filterValue: "",
    });
    const gwURL = process.env.REACT_APP_GATEWAY_URL;
    const [filteredData, setFilteredData] = React.useState([]);
    const [totalCountBilling, setTotalCountBilling] = React.useState(-1);
    const [totalCountConsump, setTotalCountConsump] = React.useState(-1);

    const startIndex = (pageSetting.page - 1) * pageSetting.itemsPerPage;
    const [hitsList, setHitsList] = React.useState([]);
    const [billingList, setBillingList] = useState([]);
    const [consumptionList, setConsumptionList] = useState([]);

    useEffect(() => {
        setHitsList([5, 10, 15, 20]);
        getBillingList()
        getCounsumptionist()
    },[])
    useEffect(() => {
        onFilterDataChangeBillingList();
    }, [billingList, pageSetting]);

    useEffect(() => {
        onFilterDataChangeConsump();
    }, [consumptionList, pageSetting]);

    const getBillingList = () => {
        showLoader(true);
        fetchApiGw({ method: "POST",data:{"page":pageSetting.page,"pageSize":pageSetting.itemsPerPage}, url: `${gwURL}`+"/api/v0/subscription/getAll",useBase:false,instanceId:""})
            .then((response) => {
                const { Data = [] } = response;
                if(response.Status === "SUCCESS"){
                    setBillingList(Data.result)
                    setTotalCountBilling(Data.totalCount)
                }
                showLoader(false);
            })
            .catch((response) => {
                setBillingList([])
                showLoader(false);
            });
    };


    const getCounsumptionist = async () => {
        setHitsList([5, 10, 15, 20]);
        showLoader(true);
        fetchApiGw({ method: "POST",data:{"page":pageSetting.page,"pageSize":pageSetting.itemsPerPage}, url: `${gwURL}`+"/api/v0/subscription/getAll",useBase:false,instanceId:""})
            .then((response) => {
                const { Data = [] } = response
                if(response.Status === "SUCCESS"){
                    setConsumptionList(Data.result)
                    setTotalCountConsump(Data.totalCount)
                }
                showLoader(false);
            })
            .catch((response) => {
                setConsumptionList([])
                showLoader(false);
            });
    };


    const onFilterDataChangeBillingList = () => {

        const endIndex =
            pageSetting.page * pageSetting.itemsPerPage > billingList.length
                ? billingList.length
                : pageSetting.page * pageSetting.itemsPerPage;

        const filterList = (
            pageSetting.searchTextBilling
                ? billingList.filter((item) =>
                    item.planName
                        .toLowerCase()
                        .includes(pageSetting.searchTextBilling.toLowerCase())
                )
                : deepCopy(billingList)
        )
            .slice(0, endIndex);
        setFilteredData(filterList);
    };

    const onFilterDataChangeConsump = () => {

        const endIndex =
            pageSetting.page * pageSetting.itemsPerPage > billingList.length
                ? consumptionList.length
                : pageSetting.page * pageSetting.itemsPerPage;

        const filterList = (
            pageSetting.searchTextConsump
                ? consumptionList.filter((item) =>
                    item.planName
                        .toLowerCase()
                        .includes(pageSetting.searchTextConsump.toLowerCase())
                )
                : deepCopy(consumptionList)
        )
            .slice(0, endIndex);
        setFilteredData(filterList);
    };


    useEffect(() => {
        setTotalCountBilling(totalCountBilling);
    }, [billingList]);

    useEffect(() => {
        setTotalCountConsump(totalCountConsump);
    }, [consumptionList]);


    const onPageChangeBilling = (pageNumber) => {
        pageSetting.page = Number(pageNumber);
        setSetting({ ...pageSetting });
        getBillingList();

    };

    const onPerPageChangeBilling = (value) => {
        pageSetting.itemsPerPage = Number(value);
        pageSetting.page = 1;
        setSetting({ ...pageSetting });
        getBillingList();
    };

    const onPageChangeConsump = (pageNumber) => {
        pageSetting.page = Number(pageNumber);
        setSetting({ ...pageSetting });
        getCounsumptionist();

    };

    const onPerPageChangeConsump = (value) => {
        pageSetting.itemsPerPage = Number(value);
        pageSetting.page = 1;
        setSetting({ ...pageSetting });
        getCounsumptionist();
    };

    const lastBilling =
        pageSetting.page * pageSetting.itemsPerPage > totalCountBilling
            ? totalCountBilling
            : pageSetting.page * pageSetting.itemsPerPage;

    const lastConsump =
        pageSetting.page * pageSetting.itemsPerPage > totalCountConsump
            ? totalCountConsump
            : pageSetting.page * pageSetting.itemsPerPage;


    const downloadFile = async (id,fileName,value) => {
        let url = ""
        if (value === "consumption"){
            url =`${gwURL}/api/v0/subscription/billing/consumption`
        }else{
            url =`${gwURL}/api/v0/subscription/billing/purchase`
        }
        fetchApiGw(
            {
                method: 'POST',
                url:url,
                useBase:false,isDevApp:false,instanceId:""
            })
            .then(function (response) {
                showLoader(false);
                // console.log("pdf response", response)
                const base64Data = response.Data;
                downloadBase64File(base64Data,fileName);
            })
            .catch((res) => {
                showLoader(false);
            })
    };
    function downloadBase64File(base64Data, fileName) {
        const byteCharacters = atob(base64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: 'application/pdf' });
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;
        downloadLink.click();
    }

    return (
        <div className="plan-billing-container" style={{paddingTop:"3.5rem"}}>
             <div className="profile-header">Billing</div>
            {isLoading?(<Skeleton height={200} style={{marginBottom:'50px'}} baseColor="#262626" highlightColor="#404040" />):(
                // <TableContent
                //     pagination={false}
                //     rowKey="planId"
                //     columns={columns(downloadFile)}
                //     data={billingList}
                // />
                <table className="subscription-table">
                    <tr>
                        <th>Purchase Date</th>
                        <th>Expiry Date</th>
                        <th>Payment Method</th>
                        <th>Paid Amount</th>
                        <th>Plan Purchased</th>
                        <th>Subscription ID</th>
                        <th>Invoice</th>
                    </tr>
                    <tr>
                        <td>{dateformatter(billingList?.planDetails?.subscriptionDate, false, false)}</td>
                        <td>{dateformatter(billingList?.planDetails?.expiryDate, false, false)}</td>
                        <td>{billingList?.paymentDetails != null ?billingList?.paymentDetails?.paymentMethod: ""}</td>
                        <td>{billingList?.paymentDetails != null ?billingList?.paymentDetails?.amount:0}</td>
                        <td>{billingList?.planDetails?.planName}</td>
                        <td>{billingList?.subscriptionId}</td>
                        <td>
                            <Restricted>
                                <button className="save-changes-btn1">
                                    <a
                                        onClick={() => downloadFile(billingList?._id,"Starter (Freemium)","")}
                                        target="_new"
                                    >
                                        {"Download"}
                                    </a>

                                </button>
                            </Restricted>
                        </td>
                    </tr>
                </table>
            )}
            <PaginationSection
                last={lastBilling}
                first={startIndex + 1}
                hitsList={hitsList}
                totalCount={totalCountBilling}
                page={pageSetting.page}
                itemsPerPage={pageSetting.itemsPerPage}
                onPageChange={onPageChangeBilling}
                onPerPageChange={onPerPageChangeBilling}
            />
            <div className="profile-header">Consumption</div>
            {isLoading?(<Skeleton height={200} style={{marginBottom:'50px'}} baseColor="#262626" highlightColor="#404040" ></Skeleton>):(
                <TableContent
                    pagination={false}
                    rowKey="planId"
                    columns={columns1(downloadFile)}
                    data={consumptionList}
                />
            )}
            <PaginationSection
                last={lastConsump}
                first={startIndex + 1}
                hitsList={hitsList}
                totalCount={totalCountConsump}
                page={pageSetting.page}
                itemsPerPage={pageSetting.itemsPerPage}
                onPageChange={onPageChangeConsump}
                onPerPageChange={onPerPageChangeConsump}
            />
        </div>

    );
};
